import { ca } from '@cian/analytics';

export const trackDropdownLinkClick = ({
  label,
  category = 'other_page',
  event = 'event',
  action = 'top_menu',
}: {
  label: string;
  event?: string;
  category?: string;
  action?: string;
}) =>
  ca(event, {
    name: 'oldevent',
    category,
    action,
    label,
  });

export const trackCatalogRealtorsLinkClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'other_page',
    action: 'top_menu',
    label: 'ListingAgents',
  });
};

export const trackCareerLinkClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'main_page',
    action: 'top_menu',
    label: 'CianCareer',
  });
};
